import MuiSlide from "@mui/material/Slide";
const Slide = MuiSlide;
export default Slide;
